var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-0.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec",
    width: 40,
    height: 40,
    rx: 6,
    transform: "translate(0.054)",
    fill: "#0296a6",
    opacity: 0.075
  }), /*#__PURE__*/React.createElement("g", {
    id: "Smock_Shop_18_N",
    transform: "translate(10.963 10.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 17.681,
    height: 18.182,
    transform: "translate(0.25 0)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98473",
    "data-name": "Path 98473",
    d: "M17.9,8.614H.54a.4.4,0,0,1-.327-.173.457.457,0,0,1-.067-.382L1.94,1.394A.518.518,0,0,1,2.433,1H16.009a.518.518,0,0,1,.493.394L18.3,8.059a.457.457,0,0,1-.067.382A.4.4,0,0,1,17.9,8.614ZM15.371,9.7v3.263h-8.2V9.7H6.146v7.614H3.072V9.7H2.047v7.614A1.058,1.058,0,0,0,3.072,18.4h12.3A1.058,1.058,0,0,0,16.4,17.315V9.7ZM2.047,7.526H3.072L4.1,2.088H3.072Zm4.356,0H7.428L7.94,2.088H6.915Zm4.1-5.438.512,5.438H12.04l-.512-5.438Zm4.868,0H14.346l1.025,5.438H16.4Z",
    transform: "translate(-0.13 -0.611)",
    fill: "#0296a6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.e984345e2efd3e9cb534a99f06c6dca6.svg";
export { ForwardRef as ReactComponent };